import React from 'react';
import { motion } from 'framer-motion';
import { FiArrowUpRight, FiMapPin, FiHeart } from 'react-icons/fi';

export default function MedModern({ data, color }) {
    // 🛡️ BLINDAGEM DE DADOS (API Real + Mock)
    const title = data?.titulo || data?.title || 'Ativo Moderno';
    const price = data?.preco || data?.price;
    const location = data?.bairro || data?.location || 'Setor Local';
    const mainImage = data?.imagensDestaque?.[0] || data?.image || 'https://images.unsplash.com/photo-1484154218962-a197022b5858';

    const formattedPrice = typeof price === 'number' 
        ? price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        : price || 'Consulte';

    return (
        <motion.div 
            whileHover={{ y: -8 }}
            className="group cursor-pointer space-y-5"
        >
            {/* 📸 VIEWPORT: ASPECT SQUARE ELITE */}
            <div className="relative overflow-hidden rounded-[2.5rem] aspect-square shadow-xl border border-[var(--border-color)]">
                <img 
                    src={mainImage} 
                    alt={title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-out" 
                />
                
                {/* Overlays Stealth */}
                <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                
                <div className="absolute top-5 right-5 flex flex-col gap-2">
                    <button className="w-10 h-10 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white hover:text-black transition-all">
                        <FiHeart size={16} />
                    </button>
                </div>

                {/* Badge de Preço Flutuante (Opcional - Estilo Airbnb Pro) */}
                <div className="absolute bottom-5 left-5 right-5 flex justify-between items-center translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                    <div className="px-5 py-2.5 rounded-2xl bg-white/90 backdrop-blur-md text-black text-[10px] font-black uppercase tracking-widest shadow-2xl border border-white">
                        Explorar Ativo
                    </div>
                    <div className="w-10 h-10 rounded-2xl bg-[var(--accent-color)] flex items-center justify-center text-black shadow-2xl"
                         style={{ backgroundColor: color || 'var(--accent-color)' }}>
                        <FiArrowUpRight size={18} />
                    </div>
                </div>
            </div>

            {/* 📄 INFO BLOCK: TIPOGRAFIA DE ALTA DENSIDADE */}
            <div className="flex flex-col gap-1 px-2">
                <div className="flex justify-between items-start gap-4">
                    <div className="flex-1 overflow-hidden">
                        <h4 className="font-black text-xl tracking-tighter uppercase truncate transition-colors duration-300"
                            style={{ color: 'var(--text-primary)' }}>
                            {title}
                        </h4>
                        <div className="flex items-center gap-2 text-[9px] font-bold uppercase tracking-[0.2em] opacity-40"
                             style={{ color: 'var(--text-secondary)' }}>
                            <FiMapPin size={10} style={{ color: color || 'var(--accent-color)' }} /> {location}
                        </div>
                    </div>
                    
                    <div className="text-right flex flex-col items-end">
                        <span className="text-[8px] font-black uppercase tracking-widest opacity-30 mb-1">A partir de</span>
                        <div className="font-black text-lg tracking-tighter"
                             style={{ color: color || 'var(--accent-color)' }}>
                            {formattedPrice}
                        </div>
                    </div>
                </div>
                
                {/* INDICADOR DE STATUS (LINE) */}
                <div className="mt-4 h-1 w-full bg-auto opacity-5 rounded-full overflow-hidden">
                    <motion.div 
                        initial={{ width: 0 }}
                        whileInView={{ width: '100%' }}
                        className="h-full opacity-40"
                        style={{ backgroundColor: color || 'var(--accent-color)' }}
                    />
                </div>
            </div>
        </motion.div>
    );
}